(() => { 
	'use strict';

	const header = document.querySelector('.header');
	const announcement = document.querySelector('.announcement-bar');
	const headerPlaceholder = document.querySelector('.header-placeholder');
	const searchToggle = document.querySelector('.search-toggle-btn');
	const searchDropdown = document.querySelector('.search-dropdown');
	const searchOverlay = document.querySelector('.search-dropdown-overlay');

	function handleScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const announcementHeight = announcement.offsetHeight;
		headerPlaceholder.style.height = `${header.offsetHeight}px`;

		if (scrollTop >= announcementHeight) {
			header.classList.add('sticky-header');
			headerPlaceholder.style.display = 'block';
		} else {
			header.classList.remove('sticky-header');
			headerPlaceholder.style.display = 'none';
		}
	}

	function toggleSearch() {
		if (searchDropdown.classList.contains('active') === false) {
			searchDropdown.classList.add('active');
			searchOverlay.style.opacity = "1";
			searchOverlay.style.pointerEvents = "auto";
		} else {
			searchDropdown.classList.remove('active');
			searchOverlay.style.opacity = "0";
			searchOverlay.style.pointerEvents = "none";
		}
	}

	window.addEventListener('scroll', handleScroll);
	searchToggle.addEventListener('click', toggleSearch);
	searchOverlay.addEventListener('click', toggleSearch);

})();